import React from 'react';
import { ArrowRight, Star, BookOpen, Users, Compass } from 'lucide-react';
export function OfertaRise() {
  return <div className="bg-rise-white min-h-screen pb-20" data-id="element-844">
      {/* Hero Section - reduced top spacing */}
      <section className="pt-4 pb-8 md:pt-6 md:pb-12 px-6 text-center" data-id="element-845">
        <div className="max-w-rise-content mx-auto flex justify-center" data-id="element-846">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-847">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-848">
              <span className="flex items-center gap-2" data-id="element-849">
                <Star size={14} className="text-rise-gold" data-id="element-850" />
                CURSURI & PROGRAME
              </span>
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight text-rise-black mb-6" data-id="element-851">
              Alege parcursul tău
            </h1>
            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed" data-id="element-852">
              De la primul pas spre liniștea interioară până la transformarea
              profundă prin abundență, iubire și prezență. Toate programele și
              sesiunile R.I.S.E. într-un singur loc.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="px-6 pb-20" data-id="element-853">
        <div className="max-w-rise-content mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-854">
          {/* Card 1: 1:1 Coaching (Highlighted) */}
          <div className="bg-white border-2 border-rise-gold rounded-2xl overflow-hidden flex flex-col shadow-lg relative transform md:-translate-y-4" data-id="element-855">
            <div className="absolute top-4 right-4 z-10 bg-rise-gold text-rise-black text-[12px] font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1" data-id="element-856">
              <Star size={12} data-id="element-857" />
              RECOMANDAT
            </div>
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-858">
              <Compass size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-859" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-860">
                <Users size={14} data-id="element-861" />
                Sesiuni 1:1
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-862">
              <div className="text-rise-gold uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-863">
                TRANSFORMARE PROFUNDĂ
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-864">
                Coaching 1 la 1
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-865">
                Ghidare personalizată pentru evoluția ta
              </p>

              <div className="mb-6 inline-flex items-center gap-2 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold uppercase tracking-wider" data-id="element-866">
                <Star size={14} className="text-rise-gold" data-id="element-867" />
                Pe bază de aplicație
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-868">
                Sesiuni individuale adaptate nevoilor tale specifice. Lucrăm
                împreună pentru a depăși blocajele, a clarifica direcția și a
                construi o viață aliniată cu adevărata ta identitate.
              </p>

              <a href="https://comunitatearise.ro/coaching1la1" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-869">
                Află mai multe <ArrowRight size={18} data-id="element-870" />
              </a>
            </div>
          </div>

          {/* Card 2: Community */}
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col shadow-sm" data-id="element-871">
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-872">
              <Users size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-873" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-874">
                <Users size={14} data-id="element-875" />
                Abonament Lunar
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-876">
              <div className="text-rise-gray uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-877">
                CONEXIUNE & CREȘTERE
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-878">
                Comunitatea R.I.S.E.
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-879">
                Spațiul tău de siguranță și evoluție
              </p>

              <div className="mb-6 inline-flex items-center gap-3 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold" data-id="element-880">
                <span className="line-through text-rise-gray/70" data-id="element-881">249 RON</span>
                <span className="text-rise-gold uppercase tracking-wider" data-id="element-882">
                  49 RON / lună
                </span>
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-883">
                Acces la întâlniri de grup, meditații ghidate, resurse exclusive
                și o rețea de oameni care împărtășesc aceleași valori. Creștem
                împreună, pas cu pas.
              </p>

              <a href="https://comunitatearise.ro/comunitaterise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-884">
                Vreau în Comunitate <ArrowRight size={18} data-id="element-885" />
              </a>
            </div>
          </div>

          {/* Card 3: Program */}
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col shadow-sm" data-id="element-886">
            <div className="h-40 bg-rise-black relative overflow-hidden flex items-center justify-center" data-id="element-887">
              <BookOpen size={80} className="text-rise-gold" strokeWidth={1.2} data-id="element-888" />
              <div className="absolute bottom-4 left-4 bg-rise-gold text-rise-black text-[13px] font-semibold px-3 py-1 rounded-full flex items-center gap-1.5" data-id="element-889">
                <BookOpen size={14} data-id="element-890" />
                Program 12 Săptămâni
              </div>
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-891">
              <div className="text-rise-gray uppercase tracking-wider text-[12px] font-bold mb-2" data-id="element-892">
                FUNDAȚIE SOLIDĂ
              </div>
              <h3 className="font-playfair text-[26px] text-rise-black mb-2" data-id="element-893">
                Programul R.I.S.E.
              </h3>
              <p className="font-dm-sans text-[15px] italic text-rise-gray mb-6" data-id="element-894">
                Realitate • Identitate • Stabilitate • Evoluție
              </p>

              <div className="mb-6 inline-flex items-center gap-3 self-start bg-rise-gold/10 text-rise-black border border-rise-gold/40 rounded-full px-4 py-2 font-dm-sans text-[14px] font-semibold" data-id="element-895">
                <span className="line-through text-rise-gray/70" data-id="element-896">1200 RON</span>
                <span className="text-rise-gold uppercase tracking-wider" data-id="element-897">
                  699 RON
                </span>
              </div>

              <p className="font-dm-sans text-[16px] text-rise-gray mb-8 flex-grow" data-id="element-898">
                Un parcurs structurat de 12 săptămâni pentru a-ți reconstrui
                fundația interioară. Module video, exerciții practice și suport
                continuu pentru o transformare de durată.
              </p>

              <a href="https://comunitatearise.ro/programulrise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors text-center flex items-center justify-center gap-2 w-full" data-id="element-899">
                Descoperă Programul <ArrowRight size={18} data-id="element-900" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Consultanta Banner - centered text + button below */}
      <section className="px-6 pb-20" data-id="element-901">
        <div className="max-w-rise-content mx-auto" data-id="element-902">
          <div className="bg-gradient-to-br from-rise-anthracite to-rise-black rounded-3xl p-10 md:p-16 flex flex-col items-center justify-center text-center gap-6 border border-rise-gold/20 relative overflow-hidden" data-id="element-903">
            {/* Subtle background glow */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-904">
              <div className="absolute -top-[50%] left-1/2 -translate-x-1/2 w-[80%] h-[200%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-905"></div>
            </div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-906">
              <div className="inline-flex items-center gap-2 text-rise-gold text-[12px] font-bold uppercase tracking-wider bg-rise-gold/10 px-4 py-1.5 rounded-full mb-6" data-id="element-907">
                <span className="w-2 h-2 rounded-full bg-rise-gold animate-pulse" data-id="element-908"></span>
                20 DE MINUTE • CADOU
              </div>
              <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white mb-4" data-id="element-909">
                Nu știi ce să alegi?
              </h2>
              <p className="font-dm-sans text-[18px] text-rise-white/80 max-w-2xl leading-relaxed mb-8" data-id="element-910">
                Rezervă o sesiune de consultanță cadou de 20 de minute. Vorbim
                despre unde te afli acum, ce îți dorești și ce parcurs ți se
                potrivește cel mai bine.
              </p>

              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center gap-2" data-id="element-911">
                Rezervă Sesiunea <ArrowRight size={18} data-id="element-912" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}